import { useContext } from 'react';

import { ActionType, StoreContext } from '../store/';

export default function useSetSelectedMessageThreadId() {
  const { dispatch } = useContext(StoreContext);

  return function setSelectedMessageThreadId(id: string | null) {
    dispatch({
      type: ActionType.SET_SELECTED_MESSAGE_THREAD_ID,
      payload: id,
    });
  };
}
